import { TYPE_STATUS_STEP_SR } from 'appx/securityStep1Welcome';
import { DateTime } from 'luxon';
import { securityReviewStore, selectSecurityReview } from '../stores/securityReviewStore';
import { getPlugin } from './schemaUtilities';
import { retrievePackageSolutionId } from './solutionUtilities';
export let PartnerSecurityReviewStatus = /*#__PURE__*/function (PartnerSecurityReviewStatus) {
  PartnerSecurityReviewStatus["new"] = "New";
  PartnerSecurityReviewStatus["submitted"] = "Submitted";
  PartnerSecurityReviewStatus["reSubmitted"] = "Re-submitted";
  PartnerSecurityReviewStatus["revoked"] = "Revoked";
  return PartnerSecurityReviewStatus;
}({});
export let OpsSecurityOpsReviewStatus = /*#__PURE__*/function (OpsSecurityOpsReviewStatus) {
  OpsSecurityOpsReviewStatus["new"] = "New";
  OpsSecurityOpsReviewStatus["processingOps"] = "Processing - Ops";
  OpsSecurityOpsReviewStatus["returnedOps"] = "Returned - Ops";
  OpsSecurityOpsReviewStatus["inReviewProdSec"] = "In Review - ProdSec";
  OpsSecurityOpsReviewStatus["returnedProdSec"] = "Returned - ProdSec";
  OpsSecurityOpsReviewStatus["pass"] = "Pass - ProdSec";
  OpsSecurityOpsReviewStatus["failedTest"] = "Failed - ProdSec";
  OpsSecurityOpsReviewStatus["expired"] = "Expired - Ops";
  return OpsSecurityOpsReviewStatus;
}({});
export async function obtainSolutionId(packageVersionId) {
  // cache the store states because we're about to update their state before running validations
  const securityReviewStateSnapshot = securityReviewStore.getState();
  if (!packageVersionId) {
    return {
      securityReview: selectSecurityReview(securityReviewStore.getState()),
      setSecurityReviewId: id => {
        securityReviewStateSnapshot.securityReview.id = id;
      },
      resetState: () => undefined // noop
    };
  }

  // modify internal state by inserting solution ids if appropriate into their respective plugins / extensions
  await retrievePackageSolutionId(packageVersionId).then(id => id && securityReviewStore.setSolutionId(id));

  // extract the newly updated data model
  const securityReview = selectSecurityReview(securityReviewStore.getState());
  return updateSecurityReview(securityReview, securityReviewStateSnapshot);
}
export function updateSecurityReview(securityReview, securityReviewStateSnapshot) {
  return {
    securityReview,
    setSecurityReviewId: id => {
      securityReviewStateSnapshot.securityReview.id = id;
    },
    resetState: () => {
      // reset stores to previous state
      securityReviewStore.setState(securityReviewStateSnapshot, true);
    }
  };
}
export function createChallenge(challengeText) {
  return {
    challenge: challengeText,
    challengeDate: new Date().toISOString()
  };
}

//Should only be called from the store and from a set function
export function removeEmptyReport(reports) {
  for (const reportItems of reports) {
    if (reportItems) {
      for (let i = reportItems.length - 1; i >= 0; i--) {
        const item = reportItems[i];
        if (!item.fileTitle && !item.mediaId) {
          reportItems.splice(i, 1);
        }
      }
    }
  }
}

//Should only be called from the store and from a set function
export function removeReport(report) {
  if (report && report.length > 0) {
    for (let i = report.length - 1; i >= 0; i--) {
      report.splice(i, 1);
    }
  }
}

//Should only be called from the store and from a set function
export function removeEmptyTestEnviroments(testEnviroments) {
  var _testEnviroments$mobi, _testEnviroments$mobi2;
  if (testEnviroments.salesforceOrgs) {
    for (let i = testEnviroments.salesforceOrgs.length - 1; i >= 0; i--) {
      const item = testEnviroments.salesforceOrgs[i];
      if (!item.id && (!item.username || !item.password || !item.loginUrl)) {
        testEnviroments.salesforceOrgs.splice(i, 1);
      }
    }
  }
  if (testEnviroments.webAppAndServices) {
    for (let i = testEnviroments.webAppAndServices.length - 1; i >= 0; i--) {
      const item = testEnviroments.webAppAndServices[i];
      if (!item.id && (!item.loginUrl || !item.apiKey)) {
        testEnviroments.webAppAndServices.splice(i, 1);
      }
    }
  }
  if (testEnviroments.clientApps) {
    for (let i = testEnviroments.clientApps.length - 1; i >= 0; i--) {
      const item = testEnviroments.clientApps[i];
      if (!item.installationLink || !item.description) {
        testEnviroments.clientApps.splice(i, 1);
      }
    }
  }
  if ((_testEnviroments$mobi = testEnviroments.mobileApps) !== null && _testEnviroments$mobi !== void 0 && _testEnviroments$mobi.installationLinks) {
    for (let i = testEnviroments.mobileApps.installationLinks.length - 1; i >= 0; i--) {
      const item = testEnviroments.mobileApps.installationLinks[i];
      if (!item.installationLink) {
        testEnviroments.mobileApps.installationLinks.splice(i, 1);
      }
    }
  }
  if ((_testEnviroments$mobi2 = testEnviroments.mobileApps) !== null && _testEnviroments$mobi2 !== void 0 && _testEnviroments$mobi2.applications) {
    for (let i = testEnviroments.mobileApps.applications.length - 1; i >= 0; i--) {
      const item = testEnviroments.mobileApps.applications[i];
      if (!item.mediaId) {
        testEnviroments.mobileApps.applications.splice(i, 1);
      }
    }
  }
}
function shouldReturnBlankStep(securityReview, securityReviewOps) {
  return !securityReviewOps || securityReviewOps.status === OpsSecurityOpsReviewStatus.expired || securityReview.status !== PartnerSecurityReviewStatus.submitted && securityReview.status !== PartnerSecurityReviewStatus.reSubmitted;
}
export function getStateForProgressIndicatorSubmitReview(securityReview, securityReviewOps, labels) {
  if ((securityReviewOps === null || securityReviewOps === void 0 ? void 0 : securityReviewOps.status) === OpsSecurityOpsReviewStatus.expired) {
    return {
      title: labels.step1Title,
      description: labels.step1Description,
      estimatedText: '',
      mainIcon: 'utility:enter',
      subIcon: '',
      status: TYPE_STATUS_STEP_SR.blank
    };
  }
  switch (securityReview.status) {
    case PartnerSecurityReviewStatus.new:
      return {
        title: labels.step1Title,
        description: labels.step1Description,
        estimatedText: '',
        mainIcon: 'utility:enter',
        subIcon: 'utility:edit',
        status: TYPE_STATUS_STEP_SR.info
      };
    case PartnerSecurityReviewStatus.revoked:
      return {
        title: labels.step1TitleRevoked,
        description: labels.step1DescriptionRevoked,
        estimatedText: '',
        mainIcon: 'utility:enter',
        subIcon: 'utility:error',
        status: TYPE_STATUS_STEP_SR.error
      };
    default:
      return {
        title: labels.step1Title,
        description: labels.step1DescriptionSubmitted,
        estimatedText: '',
        mainIcon: 'utility:enter',
        subIcon: 'utility:check',
        status: TYPE_STATUS_STEP_SR.success
      };
  }
}
export function getStateForProgressIndicatorReceivedProcessing(securityReview, securityReviewOps, labels) {
  if (shouldReturnBlankStep(securityReview, securityReviewOps)) {
    return {
      title: labels.step2Title,
      description: labels.step2Description,
      estimatedText: '',
      mainIcon: 'utility:approval',
      subIcon: '',
      status: TYPE_STATUS_STEP_SR.blank
    };
  }
  switch (securityReviewOps.status) {
    case OpsSecurityOpsReviewStatus.processingOps:
    case OpsSecurityOpsReviewStatus.new:
      return {
        title: labels.step2Title,
        description: labels.step2DescriptionProcessing,
        estimatedText: '',
        mainIcon: 'utility:approval',
        subIcon: 'utility:info_alt',
        status: TYPE_STATUS_STEP_SR.info
      };
    case OpsSecurityOpsReviewStatus.returnedOps:
      return {
        title: labels.step2Title,
        description: labels.step2DescriptionReturned,
        estimatedText: '',
        mainIcon: 'utility:approval',
        subIcon: 'utility:contact_request',
        status: TYPE_STATUS_STEP_SR.warning
      };
    default:
      return {
        title: labels.step2Title,
        description: labels.step2DescriptionSuccess,
        estimatedText: '',
        mainIcon: 'utility:approval',
        subIcon: 'utility:check',
        status: TYPE_STATUS_STEP_SR.success
      };
  }
}
export function getStateForProgressIndicatorProdSecReview(securityReview, securityReviewOps, labels) {
  if (shouldReturnBlankStep(securityReview, securityReviewOps)) {
    return {
      title: labels.step3Title,
      description: labels.step3Description,
      estimatedText: '',
      mainIcon: 'utility:password',
      subIcon: '',
      status: TYPE_STATUS_STEP_SR.blank
    };
  }
  switch (securityReviewOps.status) {
    case OpsSecurityOpsReviewStatus.inReviewProdSec:
      return {
        title: labels.step3Title,
        description: labels.step3DescriptionInReview,
        estimatedText: '',
        mainIcon: 'utility:password',
        subIcon: 'utility:info_alt',
        status: TYPE_STATUS_STEP_SR.info
      };
    case OpsSecurityOpsReviewStatus.returnedProdSec:
      return {
        title: labels.step3Title,
        description: labels.step3DescriptionReturned,
        estimatedText: '',
        mainIcon: 'utility:password',
        subIcon: 'utility:contact_request',
        status: TYPE_STATUS_STEP_SR.warning
      };
    case OpsSecurityOpsReviewStatus.failedTest:
      return {
        title: labels.step3TitleFailed,
        description: labels.step3DescriptionError,
        estimatedText: '',
        mainIcon: 'utility:password',
        subIcon: 'utility:error',
        status: TYPE_STATUS_STEP_SR.error
      };
    case OpsSecurityOpsReviewStatus.pass:
      return {
        title: labels.step3Title,
        description: labels.step3DescriptionSuccess,
        estimatedText: '',
        mainIcon: 'utility:password',
        subIcon: 'utility:check',
        status: TYPE_STATUS_STEP_SR.success
      };
    default:
      return {
        title: labels.step3Title,
        description: labels.step3Description,
        estimatedText: '',
        mainIcon: 'utility:password',
        subIcon: '',
        status: TYPE_STATUS_STEP_SR.blank
      };
  }
}
export function getStateForProgressIndicatorFinalStep(securityReview, securityReviewOps, labels) {
  if (securityReviewOps.status !== OpsSecurityOpsReviewStatus.expired && shouldReturnBlankStep(securityReview, securityReviewOps)) {
    return {
      title: labels.step4Title,
      description: labels.step4DescriptionSuccess,
      estimatedText: '',
      mainIcon: 'utility:multi_select_checkbox',
      subIcon: '',
      status: TYPE_STATUS_STEP_SR.blank
    };
  }
  switch (securityReviewOps.status) {
    case OpsSecurityOpsReviewStatus.pass:
      return {
        title: labels.step4Title,
        description: labels.step4DescriptionSuccess,
        estimatedText: '',
        mainIcon: 'utility:multi_select_checkbox',
        subIcon: 'utility:check',
        status: TYPE_STATUS_STEP_SR.success
      };
    case OpsSecurityOpsReviewStatus.expired:
      return {
        title: labels.step4TitleExpired,
        description: labels.step4DescriptionExpired,
        estimatedText: '',
        mainIcon: 'utility:list',
        subIcon: 'utility:error',
        status: TYPE_STATUS_STEP_SR.error
      };
    default:
      return {
        title: labels.step4Title,
        description: labels.step4DescriptionSuccess,
        estimatedText: '',
        mainIcon: 'utility:multi_select_checkbox',
        subIcon: '',
        status: TYPE_STATUS_STEP_SR.blank
      };
  }
}
export function lastChallengeRaised(securityReview) {
  const raiseAChallenge = getPlugin(securityReview, 'securityReview/plugins/RaiseAChallenge');
  if (raiseAChallenge && raiseAChallenge.challenges) {
    return raiseAChallenge.challenges.sort((a, b) => {
      const aTime = DateTime.fromISO(a.challengeDate);
      const bTime = DateTime.fromISO(b.challengeDate);
      if (aTime.toMillis() === bTime.toMillis()) {
        return 0;
      }
      return aTime > bTime ? -1 : 1;
    })[0];
  }
  return undefined;
}